import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-voltage-bg flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-voltage-blue/15 blur-[100px] rounded-full" />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative voltage-card w-full max-w-md p-10 space-y-6"
      >
        <div className="text-center">
          <div className="inline-flex p-3 border border-voltage-yellow/60 mb-4">
            <Zap className="w-6 h-6 text-voltage-yellow" />
          </div>
          <h1 className="font-display font-black text-3xl uppercase tracking-tight">
            Admin <span className="text-voltage-yellow">Console</span>
          </h1>
          <p className="text-voltage-muted text-sm mt-2 font-mono">VOLTAGE VIPERS · RESTRICTED ACCESS</p>
        </div>

        <div>
          <label className="overline mb-2 block">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email"
            className="w-full bg-transparent border-b-2 border-voltage-blue/60 focus:border-voltage-yellow outline-none py-2 text-white"
          />
        </div>
        <div>
          <label className="overline mb-2 block">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
            className="w-full bg-transparent border-b-2 border-voltage-blue/60 focus:border-voltage-yellow outline-none py-2 text-white"
          />
        </div>

        {error && (
          <div data-testid="login-error" className="border border-red-500/60 bg-red-500/10 text-red-400 text-sm p-3 font-mono">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={submitting}
          data-testid="admin-login-submit"
          className="btn-primary clip-bolt w-full disabled:opacity-50"
        >
          <Zap className="w-4 h-4" /> {submitting ? "Authenticating..." : "Sign In"}
        </button>
      </form>
    </div>
  );
}
